import React from 'react';
import MainSidebar from '../components/layout/sidebar/MainSidebar';
import APIStatus from "../components/layout/status/APIStatus";
//import { makeStyles } from "@mui/styles";
//import { ThemeProvider } from "@mui/material/styles";
//import clsx from 'clsx';
import AppBar from "../components/layout/appbar/AppBar";
import {useSelector} from "react-redux";
//import DefaultLayoutStyles from "../styles/jss/DefaultLayout";
import theme from "../theme";
import {CssBaseline, Box} from "@mui/material";
import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';
import {cfg} from "../config";
import { useQuery } from "@tanstack/react-query";
import { drawerWidth } from "../styles/aero.js";

//const useStyles = makeStyles(DefaultLayoutStyles);

const getOrg = async () => {
  const session = await fetchAuthSession();

  return await axios
    .get(`${cfg.apiUrl}/org`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: session.tokens?.idToken,
      },
    });
}

const DefaultLayout = ({children, ...props}) => {
    //const classes = useStyles();
    const sidebar = useSelector(state => state.sidebar);
    const [status, setStatus] = React.useState(true);

    const { data: sub, error } = useQuery({queryKey: ["getOrg"], queryFn: getOrg});
    if (error) console.log(error);

    React.useEffect(() => {
        fetchAuthSession()
            .then(session => {
                axios.get(`${cfg.apiUrl}/status`, {
                    headers: {
                        "Authorization": session.tokens?.idToken,
                        "Content-Type": "application/json"
                    }
                })
                    .then(resp => {
                        if(resp.status === 200) {
                            if(resp.data.status === 'ok') {
                                setStatus(true)
                            } else {
                                setStatus(false)
                            }
                        } else {
                            setStatus(false)
                        }
                    })
                    .catch(e => {
                        setStatus(false)
                    })
            })
    }, []);

    return (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh'
        }}>
            <CssBaseline/>
            {!status && <APIStatus />}
            <AppBar title={props.title} org={sub ? sub.data : ''}/>
            <MainSidebar/>
            <main><Box sx={{
              flexGrow: 1,
              height: '100%',
              padding: 3,
              backgroundColor: 'rgba(0,0,0,0.02)',
              // transition: theme.transitions.create(['margin', 'width'], {
              //     easing: theme.transitions.easing.sharp,
              //     duration: theme.transitions.duration.leavingScreen,
              // }),
              ...(sidebar.open && sidebar.screenWidth > theme.breakpoints.values.sm && {
                marginLeft: '260px',//drawerWidth,

                // transition: theme.transitions.create(['margin', 'width'], {
                //     easing: theme.transitions.easing.easeOut,
                //     duration: theme.transitions.duration.enteringScreen,
                // }),
              })
            }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: [0,1],
                  // necessary for content to be below app bar
                  ...theme.mixins.toolbar,
                  // justifyContent: 'flex-end',
                }} />
                {children}
            </Box></main>
            {/*Issue with footer: sitting on top of content.*/}
            {/*<MainFooter />*/}
        </Box>
    );
}

export default DefaultLayout;